import { useNavigate } from 'react-router-dom';

export default function Catalog() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Catalogue</h1>
        <p className="mt-2 text-gray-600">Gérez votre catalogue de produits</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <button
          onClick={() => navigate('/products')}
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow text-left"
        >
          <div className="text-4xl mb-3">📦</div>
          <h3 className="text-lg font-semibold text-gray-900">Produits</h3>
          <p className="text-sm text-gray-600 mt-1">Gérer les produits</p>
        </button>

        <button
          onClick={() => navigate('/categories')}
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow text-left"
        >
          <div className="text-4xl mb-3">🏷️</div>
          <h3 className="text-lg font-semibold text-gray-900">Catégories</h3>
          <p className="text-sm text-gray-600 mt-1">Organiser par catégories</p>
        </button>

        <button
          onClick={() => navigate('/pos/reception')}
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow text-left"
        >
          <div className="text-4xl mb-3">🤖</div>
          <h3 className="text-lg font-semibold text-gray-900">Import AI</h3>
          <p className="text-sm text-gray-600 mt-1">Import intelligent</p>
        </button>

        <button
          onClick={() => navigate('/inventory')}
          className="bg-white rounded-lg shadow p-6 hover:shadow-lg transition-shadow text-left"
        >
          <div className="text-4xl mb-3">📊</div>
          <h3 className="text-lg font-semibold text-gray-900">Stocks</h3>
          <p className="text-sm text-gray-600 mt-1">Gérer les stocks</p>
        </button>
      </div>
    </div>
  );
}
